import { UpdateVision } from '@griply/types';

import { dateToFirestoreTimestamp } from '../converters/date-to-firestore-timestamp';
import { FirestoreInstance } from '../types/firestore';
import { FirestoreCollections } from '../types/firestore-collections';

export type UpdateVisionOptions<
  TDocRef = unknown,
  TTimestamp = unknown,
  TFieldValue = unknown,
  TDb = FirestoreInstance,
> = {
  vision: UpdateVision;
  doc: (db: NoInfer<TDb>, path: string, ...rest: string[]) => TDocRef;
  updateDoc: (
    ref: NoInfer<TDocRef>,
    data: Record<string, unknown>,
  ) => Promise<void>;
  db: TDb;
  timestampFromDate: (date: Date) => TTimestamp;
  serverTimestamp: () => TFieldValue;
};

export const updateVision = async <
  TDocRef,
  TTimestamp,
  TFieldValue,
  TDb = FirestoreInstance,
>(
  options: UpdateVisionOptions<TDocRef, TTimestamp, TFieldValue, TDb>,
): Promise<void> => {
  const { vision, doc, updateDoc, db, timestampFromDate, serverTimestamp } =
    options;

  const ref = doc(db, FirestoreCollections.Visions, vision.id);
  const convertedUpdates = dateToFirestoreTimestamp(vision, timestampFromDate);

  await updateDoc(ref, {
    ...convertedUpdates,
    updatedAt: serverTimestamp(),
  });
};
